// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_rx-5";
export var filledCircle = "_rx-4";
export var historyEntry = "_rx-3";
export var messageSideLeft = "_rx-1";
export var messageSideRight = "_rx-2";
export var orderTrackingCarouselWrapper = "_rx-6";
export var orderTrackingInfoContainer = "_rx-0";